import { render, staticRenderFns } from "./dingdan.vue?vue&type=template&id=22ed9085&scoped=true"
import script from "./dingdan.vue?vue&type=script&lang=js"
export * from "./dingdan.vue?vue&type=script&lang=js"
import style0 from "./dingdan.vue?vue&type=style&index=0&id=22ed9085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed9085",
  null
  
)

export default component.exports